module.exports = __webpack_public_path__ + "static/media/it-specialist-html-and-css.8e107284.png";